export const APP_ROUTES = {
    login: "/login",
    register: "/register",
    dashboard: "/dashboard",
    settings: "/settings",
    tokens: "/tokens",
    strategies: "/strategies",
    orders: "/orders",
    analytics: "/analytics",
    pnlReport: "/reports/pnl",
    journal: "/journal",
    awaitingActivation: "/awaiting-activation",
    admin: "/admin",
    adminLimits: "/admin/limits",
};
export const resolvePostAuthPath = (user) => user.activation_status === "active" ? APP_ROUTES.dashboard : APP_ROUTES.awaitingActivation;
export const resolveHomePath = (session) => {
    if (!session)
        return APP_ROUTES.login;
    return resolvePostAuthPath(session.user);
};
